import { toastService } from "./toastService";

const request = async (method, path, data) => {
    let token = JSON.parse(localStorage.getItem('token'));

    let options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        },
    };

    if (method !== 'GET') {
        options.method = method;
        options.body = JSON.stringify(data);
    }

    try {
        const response = await fetch(process.env.REACT_APP_API_BASE_URL + path, options);

        let responseData = null;
        try {
            responseData = await response.json();
        } catch {
            if (response.status >= 500) {
                toastService.error('Oops! Something went wrong on the server. Please try again later.');
            }
            throw new Error('Network or server error. Please try again later.');
        }

        if (!response.ok) {
            const message = responseData?.err || responseData?.message || response.statusText;

            if (response.status >= 500) {
                toastService.error(`Server error: ${message}`);
            }

            const err = new Error(message);
            err.__contextError = true;  
            throw err;
        }

        return responseData;
    } catch (err) {
        if (!err.__contextError) {
            toastService.error(err.message || 'Oops! Something went wrong. Please try again.');
        }
        throw err;  
    }
};

export default request;
